export const SET_EXIST_ACTIVITY = 'SET_EXIST_ACTIVITY' // 是否有硬件参与押金活动
